import {
  buildHasuraQuery,
  ConfigurationType as MuiAdminConfigurationType,
  DefaultConfiguration as MuiFormDefaultConfiguration,
  HasuraQuery,
} from '@kirz/mui-admin';

import { api } from 'services/api';

const defaultSnackbarOptions = {
  disableWindowBlurListener: true,
  autoHideDuration: 1000,
  anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
};

export const Configuration = () => ({
  muiAdmin: {
    ...MuiFormDefaultConfiguration,
    translations: {
      valueRequired: 'Waarde vereist',
      wrongEmailFormat: 'Ongeldig formaat',
      wrongPhoneFormat: 'Ongeldig formaat',
      wrongDateFormat: 'Ongeldig formaat',
      autocompletePlaceholder: 'Typ en druk op "Enter"',
      tableSearchPlaceholder: 'Zoeken op naam',
      tableAddFilterTooltip: 'Filter toevoegen',
      tableNoRows: 'Geen bestanden',
      unexpectedError: 'Er is een fout opgetreden',
      deleteTableRow: 'Verwijderen',
      attachmentsZoneTitle: 'Selecteer bijlagetype',
      attachmentsZoneLabel: 'Bijlagetype',
      attachmentsZoneAccept: 'Uploaden',
      attachmentsZoneCancel: 'Annuleren',
      attachmentsUploadedSuccessfully: 'Bestanden geüpload',
      attachmentsUploadedOrDropFileHere: 'Sleep of selecteer een bestand',
      attachmentsNoFiles: 'Geen geüploade bestanden',
      attachmentsFileMenuDownload: 'Downloaden',
      attachmentsFileMenuDelete: 'Verwijderen',
      addNewAutocompleteValue: 'Toevoegen',
      cancel: 'Annuleren',
      addNew: 'Toevoegen',
      copied: 'Gekopieerd',
      create: 'Aanmaken',
      open: 'Openen',
      save: 'Opslaan',
      saveAndExit: 'Opslaan en afsluiten',
      nullSelectOptionText: 'Geen',
      changesNotSaved: 'Wijzigingen niet opgeslagen!',
      youWillLoseAllUnsavedData:
        'Bij afsluiten gaan alle niet-opgeslagen gegevens verloren.',
      goAnyways: 'Toch doorgaan',
      clear: 'Wissen',
      noFile: 'Niet beschikbaar',
      notSet: 'Niet ingesteld',
      columnFillAvailableSpace: 'Beschikbare ruimte opvullen',
      resetTableState: 'Terugzetten naar standaardwaarden',
      attachmentsZoneText: 'Bestanden',
      exportCsv: 'CSV exporteren',
      attachmentsFileMenuMove: 'Verplaatsen',
      attachmentsFileMenuRename: 'Hernoemen',
      attachmentsZoneFileRenameTitle: 'Hernoemen',
      attachmentsZoneFileRenameText: 'Hernoemen',
      attachmentsZoneFileMoveTitle: 'Verplaatsen',
      attachmentsZoneFileMoveText: 'Verplaatsen',
      saved: 'Opgeslagen',
      attachmentsZoneFileRenameLabel: 'Hernoemen',
    },
    alerts: {
      maxStackSize: 3,
      variants: {
        success: { variant: 'success', ...defaultSnackbarOptions },
        info: { variant: 'info', ...defaultSnackbarOptions },
        default: { variant: 'default', ...defaultSnackbarOptions },
        error: { variant: 'error', ...defaultSnackbarOptions },
        warning: { variant: 'warning', ...defaultSnackbarOptions },
      },
      snackbars: {
        entityCreated: { text: 'Opgeslagen', variant: 'success' },
        entityUpdated: { text: 'Opgeslagen', variant: 'success' },
        entityDeleted: { text: 'Verwijderd', variant: 'success' },
      },
    },
    defaultDeleteConfirm: {
      title: 'Bent u zeker dat u wil verwijderen?',
      accept: 'Verwijderen',
      cancel: 'Annuleren',
    },
    defaultDeleteFileConfirm: {
      title: 'Bent u zeker dat u wil verwijderen?',
      accept: 'Verwijderen',
      cancel: 'Annuleren',
    },
    defaultPhoneCountry: 'RU',
    defaultLocale: 'en',
    availableLocales: ['en'],
    defaultDateFormat: 'DD.MM.YYYY',
    hasura: {
      ...MuiFormDefaultConfiguration.hasura,
      async request(query, options) {
        const { extractResult, ...data } = buildHasuraQuery(query);

        const { data: response } = await api.hasuraClientInstance.post(
          '',
          data,
          {
            headers: {
              ...(options?.showRemoved && {
                'X-Hasura-Removed-Entities': 'true',
              }),
            },
          },
        );

        return extractResult ? extractResult(response.data) : response.data;
      },
      subscribe(request: HasuraQuery, onNext: (value: any) => void) {
        const { extractResult, query, variables } = buildHasuraQuery(request);

        const onNextResponse = ({ data }: any) => {
          onNext(
            typeof extractResult === 'function' ? extractResult(data) : data,
          );
        };

        const unsubscribe = api.hasuraWsClientInstance!.subscribe(
          {
            query,
            variables,
          },
          {
            next: onNextResponse,
            error: () => {},
            complete: () => {},
          },
        );

        return unsubscribe;
      },
      primaryKey: 'id',
    },
    rest: {
      ...MuiFormDefaultConfiguration.rest,
      client: api.instance,
    },
  } as MuiAdminConfigurationType,
});
